export default __webpack_public_path__ + "d2edd184fbda31b533ae9a7d075a5991.png";